import FilterLayout from './FilterLayout.vue'

FilterLayout.install = function (Vue) {
  Vue.component(FilterLayout.name, FilterLayout)
}

export default FilterLayout
